module.exports = __webpack_public_path__ + "81b0f1f02517f0cf91939b4c7591878f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-basic-1.png
// module id = 3189
// module chunks = 0